// eslint-disable-next-line no-unused-vars
import useAxios, { Options } from "axios-hooks";
// eslint-disable-next-line no-unused-vars
import { AxiosRequestConfig } from "axios";
import { useContext } from "react";
import axios from "axios";
import { AuthContext } from "../../contexts/AuthContext";
import efpaConfig from "../../utils/efpaConfig";
import getLoginType from "../../utils/loginConfig";
import { navigate } from "gatsby-link";

/**
 *
 * @param {AxiosRequestConfig} config
 * @param {Options} options
 */
export function useAxiosClient(config, options = { useCache: false }) {
  const { token, login } = useContext(AuthContext);
  axios.defaults.baseURL = efpaConfig.BASE_URL;
  axios.defaults.headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  // response interceptor intercepting 401 responses, refreshing token and retrying the request
  axios.interceptors.response.use(
    (response) => response,
    async (error) => {
      const config = error.config;
      const status = error?.response?.status || 400;
      const axiosError = error?.isAxiosError;
      if (status === 401 && !config?._retry && axiosError) {
        config._retry = true;
        login(false);
        const newLoginType = getLoginType();
        navigate(`${newLoginType.home}login`);
        return axios(config);
      }

      return Promise.reject(error);
    }
  );

  return useAxios(
    {
      method: "get", // default
      ...config,
    },
    options
  );
}
